"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PlusShieldSymbolIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "20",
  height: "24",
  viewBox: "0 0 20 24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#4CB05D",
      d: "M1.863 10a.9.9 0 01-.9-.9V1.176a.9.9 0 111.799 0V9.1a.9.9 0 01-.899.9",
      mask: "url(#mask-2)",
      transform: "translate(-1 -1) translate(6 6) translate(3 .725)",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#4CB05D",
      d: "M0 1.137a.9.9 0 01.9-.9h7.924c.497 0 .902.403.902.9s-.405.9-.902.9H.9a.9.9 0 01-.9-.9",
      mask: "url(#mask-4)",
      transform: "translate(-1 -1) translate(6 6) translate(0 4.725)",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFF",
      d: "M3.302 2.795C1.986 3.21.996 4.551 1 5.914v.414a.89.89 0 101.782 0v-.416c-.002-.588.482-1.237 1.068-1.422a22.585 22.585 0 0114.234.004c.553.174 1.056.851 1.056 1.42v8.785c-.005.77-.471 2.112-1.084 2.752-3.231 3.317-5.318 5.115-7.096 5.115-1.775 0-3.862-1.797-7.087-5.107-.62-.65-1.087-1.99-1.091-2.753v-3.02a.89.89 0 10-1.782 0v3.026c.005 1.145.6 2.946 1.59 3.984 3.652 3.749 5.949 5.652 8.37 5.652 2.423 0 4.721-1.904 8.377-5.66.985-1.026 1.579-2.83 1.585-3.984v-8.79c0-1.341-1.01-2.711-2.288-3.116a24.51 24.51 0 00-15.332-.003z",
      transform: "translate(-1 -1)",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFF",
      d: "M1 9a1 1 0 112 0 1 1 0 01-2 0",
      transform: "translate(-1 -1)",
      className: "svg-fill-secondary"
    })]
  })]
});

PlusShieldSymbolIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(PlusShieldSymbolIcon);

exports.default = _default;